import { observer } from "mobx-react";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import {
  Grid,
  Message,
  MessageProps,
  Modal,
  TransitionablePortal,
} from "semantic-ui-react";
import { Link } from "../button";
import { IErrorModel } from "./ErrorModel";

interface IErrorMessage extends WithTranslation, MessageProps {
  errorobj: IErrorModel;
}

@observer
class ErrorMessage extends React.Component<IErrorMessage, any> {
  public state = { open: false };
  private timeout = 5000;

  public close = () => this.setState({ open: false });
  public open = () => this.setState({ open: true });
  public render() {
    const {
      tigger,
      code,
      title,
      message,
      technicalStack,
    } = this.props.errorobj;
    const { t, ...rest } = this.props;
    const { open } = this.state;
    return (
      <TransitionablePortal open={tigger} onOpen={this.handleOpen}>
        <Message negative style={styles.messageStyle}>
          <Message.Header>{title}</Message.Header>
          {message}
          {technicalStack ? (
            <Modal
              trigger={
                <Grid onClick={this.open}>
                  <Grid.Row>
                    <Link attached="bottom right" shade={1}>
                      {t("ErrorMessage.detail")}
                    </Link>
                  </Grid.Row>
                </Grid>
              }
              onOpen={this.open}
              open={open}
              onClose={this.close}
              header={`${code}: ${title}`}
              content={technicalStack}
            />
          ) : null}
        </Message>
      </TransitionablePortal>
    );
  }

  private handleOpen = () => {
    setTimeout(() => {
      this.props.errorobj.setField({ fieldname: "tigger", value: false });
    }, this.timeout);
  };
}
const styles: any = {
  messageStyle: {
    left: "30%",
    position: "fixed",
    top: "40%",
    zIndex: 1000,
    width: "40vw",
  },
};
export default withTranslation()(ErrorMessage);
